import { RefreshIcon } from "../../../assets/icons";
import { Button } from "@altimateai/lego";
import { useLineageDispatch } from "../context/LineageProvider";
import { CLL } from "../cllUtils";
import { initLineage } from "../api";
import { setCollectColumns, setMoreTables, setSelectedColumn } from "../context/LineageSlice";
import { createPortal } from "react-dom";
import { ReactFlowInstance } from "reactflow";
import styles from "./styles.module.scss";

const ResetButton = ({ flow }: { flow: ReactFlowInstance }) => {
  const resetContainer = document.getElementById("reset-container");
  const lineageDispatch = useLineageDispatch();
  if (!resetContainer) {
    return null;
  }
  return createPortal(
    <Button
      variant="default"
      size="xs"
      onClick={() => {
        flow.setNodes([]);
        flow.setEdges([]);
        lineageDispatch(setSelectedColumn({ table: "", name: "" }));
        lineageDispatch(setCollectColumns({}));
        lineageDispatch(setMoreTables({}));
        initLineage();
        CLL.cancel();
      }}
      data-testid="reset-btn"
      className={styles.reset_btn}
    >
      <RefreshIcon />
      <span>Reset</span>
    </Button>,
    resetContainer
  );
};

export default ResetButton;
